import { render, staticRenderFns } from "./AddAutoMatchingOrder.vue?vue&type=template&id=0c3d724b&scoped=true"
import script from "./AddAutoMatchingOrder.vue?vue&type=script&lang=js"
export * from "./AddAutoMatchingOrder.vue?vue&type=script&lang=js"
import style0 from "./AddAutoMatchingOrder.vue?vue&type=style&index=0&id=0c3d724b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3d724b",
  null
  
)

export default component.exports